import React from 'react';
import { Chip, ChipTab } from '../../lib/types';
import PortalTable, { Column } from '../../components/PortalTable/PortalTable';
import ChipRow from './ChipRow';

const stockColumns: Column[] = [
  { key: 'chipId', label: 'Chip ID' },
  { key: 'petName', label: 'Pet Name' },
  { key: 'breed', label: 'Breed' },
  { key: 'dateAdded', label: 'Date Added' },
  { key: 'status', label: 'Status' },
  { key: 'action', label: 'Action' },
];

const registeredColumns: Column[] = [
  { key: 'chipId', label: 'Chip ID' },
  { key: 'petName', label: 'Pet Name' },
  { key: 'breed', label: 'Breed' },
  { key: 'owner', label: 'Owner' },
  { key: 'registered', label: 'Registered' },
  { key: 'registeredBy', label: 'Registered By' },
  { key: 'action', label: 'Action' },
];

const searchColumns: Column[] = [
  { key: 'chipId', label: 'Chip ID' },
  { key: 'petName', label: 'Pet Name' },
  { key: 'breed', label: 'Breed' },
  { key: 'owner', label: 'Owner' },
  { key: 'date', label: 'Date' },
  { key: 'registeredBy', label: 'Registered By' },
  { key: 'status', label: 'Status' },
  { key: 'action', label: 'Action' },
];

interface ChipsTableProps {
  chips: Chip[];
  tab: ChipTab;
  searchQuery: string;
  onRegister: (chipId: string) => void;
  onDetail: (chip: Chip) => void;
  onTransfer: (chip: Chip) => void;
  onRecall: (chip: Chip) => void;
}

export default function ChipsTable({
  chips,
  tab,
  searchQuery,
  onRegister,
  onDetail,
  onTransfer,
  onRecall,
}: ChipsTableProps) {
  const columns = tab === 'all' ? searchColumns : tab === 'stock' ? stockColumns : registeredColumns;

  const emptyMessage = searchQuery ? `No chips matching "${searchQuery}"` : 'No chips in this category yet';

  return (
    <PortalTable columns={columns} isEmpty={chips.length === 0} emptyMessage={emptyMessage}>
      {chips.map((chip) => (
        <ChipRow
          key={chip.id}
          chip={chip}
          tab={tab}
          onRegister={onRegister}
          onDetail={onDetail}
          onTransfer={onTransfer}
          onRecall={onRecall}
        />
      ))}
    </PortalTable>
  );
}
